import {useMemo} from 'react';

import {useSelector} from 'react-redux';

import {
  selectCurrentAddressKey,
  selectAllAddresses,
  selectCurrentDeliveryMethod,
  selectUser,
} from '~/shared/store/selectors';
import {findAddressByAddressKey, isAddressKeyContainAddressId} from '~/shared/utils/address';
import {DeliveryMethods} from '~/shared/consts/restaurantConsts';
import {isAddress} from '~/shared/store/models';
import {shouldRequireAddressPhoneUpdate} from '~/shared/services/checkout';

const useCheckoutAddress = () => {
  const currentAddressKey = useSelector(selectCurrentAddressKey);
  const allAddresses = useSelector(selectAllAddresses);
  const currentDeliveryMethod = useSelector(selectCurrentDeliveryMethod);
  const userData = useSelector(selectUser);

  const currentAddress = useMemo(
    () => findAddressByAddressKey(allAddresses, currentAddressKey),
    [allAddresses, currentAddressKey],
  );

  const deliveryMethod = useMemo(() => currentDeliveryMethod || DeliveryMethods.DELIVERY, [currentDeliveryMethod]);

  const isPickupMode = useMemo(() => deliveryMethod === DeliveryMethods.PICKUP, [deliveryMethod]);

  const isAddressWithoutId = useMemo(
    () => currentAddressKey && !isAddressKeyContainAddressId(currentAddressKey),
    [currentAddressKey],
  );

  const isPhoneUpdateRequired = useMemo(() => {
    if (!currentAddress || !userData.data) {
      return false;
    }

    return shouldRequireAddressPhoneUpdate(
      userData.data.cellphone,
      isAddress(currentAddress) ? currentAddress.phone01 : '',
    );
  }, [currentAddress, userData]);

  return {
    isPickupMode,
    deliveryMethod,
    currentAddressKey,
    currentAddress,
    isAddressWithoutId,
    isPhoneUpdateRequired,
  };
};

export default useCheckoutAddress;
